import SubprocessorsPage from './Subprocessors';

export default SubprocessorsPage;
